import {
  CardProps,
  icons,
  MenuItem,
  ReportsPageAFY,
  sizesIcon,
  variantsAvatar,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { TFunction } from "i18next";
import React from "react";
import { dataChip } from "../resources/customReportsDTO";

export const CustomReportPageView = (props: {
  Tl: TFunction;
  reportCard?: CardProps[];
  openReport: (item: MenuItem, card: CardProps) => void;
  newDownData: CardProps[];
  onClickMonthReport: (item: MenuItem) => void;
  dataSeries: any;
  dataCategories: any;
  filterCalendar: (item: any) => void;
  clearCalendar: () => void;
}) => {
  return (
    <ReportsPageAFY
      titleChart={props.Tl(`salesReport.barChart.title`)}
      yAxisTitleChart={props.Tl(`salesReport.barChart.yAxisTitle`)}
      backgroundColorSearch="#F6F7FB"
      bgChipSelected="#EBEEF6"
      bgChips="#fff"
      iconBgColor="#F6F7FB"
      iconColor="#3A56A1"
      iconColorSearch="#3A56A1"
      heightChart="323px"
      iconAvatar={icons.Search}
      iconSearch={icons.Search}
      sizeIcon={sizesIcon.standard}
      sizesIconSearch={sizesIcon.standard}
      avatarVariant={variantsAvatar.rounded}
      dataChips={dataChip}
      data={props.reportCard}
      optionList={[
        {
          id: "1",
          name: "Previsualizar",
        },
      ]}
      downData={props.newDownData}
      series={props.dataSeries}
      categories={props.dataCategories}
      onClickActionButton={props.openReport}
      onClickChip={props.onClickMonthReport}
      onChangeData={props.filterCalendar}
      onCloseCalendar={props.clearCalendar}
      onBlurSearch={() => {}}
      onBlurTextSearch={function noRefCheck() {}}
      onChangeSearch={function noRefCheck() {}}
      onChangeTextSearch={function noRefCheck() {}}
      onCloseSearch={function noRefCheck() {}}
    />
  );
};
